import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-lg-row new-stepper",
  id: "kt_stepper_example_vertical",
  ref: "completeProfileStepperForm"
}
const _hoisted_2 = { class: "d-flex flex-row-auto w-300px w-lg-300px" }
const _hoisted_3 = { class: "stepper-nav flex-start p-5" }
const _hoisted_4 = { class: "flex-row-fluid p-5" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "d-flex flex-stack" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Back ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Skip ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick", "data-kt-indicator", "disabled"]
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepperNav = _resolveComponent("StepperNav")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StepperNav, {
          stepperNo: "1",
          stepperTitle: "Personal Profile",
          stepperDescription: "",
          "col-class": {
            current: _ctx.currentStep == 0,
            completed: _ctx.currentStep > 0,
          }
        }, null, 8, ["col-class"]),
        _createVNode(_component_StepperNav, {
          stepperNo: "2",
          stepperTitle: "Business Details",
          stepperDescription: "",
          "col-class": {
            current: _ctx.currentStep == 1,
          }
        }, null, 8, ["col-class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        "initial-values": _ctx.formData,
        "validation-schema": _ctx.formStepSchema,
        ref: "completeProfileForm"
      }, {
        default: _withCtx(({ handleSubmit, values, validate }) => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.nextStep)), ["prevent"]),
            class: "form w-lg-500px mx-auto",
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex-column", { current: _ctx.currentStep === 0 }]),
                "data-kt-stepper-element": "content"
              }, [
                _createVNode(_component_Step1, {
                  values: values,
                  onOwnerStateChange: _ctx.handleOwnerStateChange,
                  onOwnerStateBlur: _ctx.handleOwnerStateBlur,
                  onOwnerCountryChange: _ctx.handleOwnerCountryChange,
                  onOwnerCountryBlur: _ctx.handleOwnerCountryBlur
                }, null, 8, ["values", "onOwnerStateChange", "onOwnerStateBlur", "onOwnerCountryChange", "onOwnerCountryBlur"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-column", { current: _ctx.currentStep === 1 }]),
                "data-kt-stepper-element": "content"
              }, [
                _createVNode(_component_Step2, {
                  values: values,
                  onBusinessStateChange: _ctx.handleBusinessStateChange,
                  onBusinessStateBlur: _ctx.handleBusinessStateBlur,
                  onBusinessCountryChange: _ctx.handleBusinessCountryChange,
                  onBusinessCountryBlur: _ctx.handleBusinessCountryBlur
                }, null, 8, ["values", "onBusinessStateChange", "onBusinessStateBlur", "onBusinessCountryChange", "onBusinessCountryBlur"])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-new-design-secondary w-180-px me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args))),
                  disabled: _ctx.loading
                }, _hoisted_11, 8, _hoisted_9)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-light w-180-px me-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.skipCompleteProfile && _ctx.skipCompleteProfile(...args)))
                }, _hoisted_13),
                (_ctx.currentStep === _ctx.totalSteps - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.submitCompleteProfileForm(values)),
                      type: "button",
                      class: "btn btn-new-design-primary w-180-px",
                      "data-kt-stepper-action": "submit",
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      disabled: _ctx.loading
                    }, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" }),
                        _hoisted_16
                      ]),
                      _hoisted_17
                    ], 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: validate,
                      class: "btn btn-new-design-primary w-180-px"
                    }, " Next ", 8, _hoisted_18))
              ])
            ])
          ], 40, _hoisted_5)
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema"])
    ])
  ], 512))
}